export default __webpack_public_path__ + "static/img-nhs-process-e582dfc2f40a5c4697674d8cbc66b1cd.png";